import * as Scrivito from "scrivito";
import I18n from "^/config/i18n";
import AddButton from "^/Components/AddButton";
import EventNode from "./EventNode";

function RecommendedEvents({
  search,
  category,
  recommended,
  language,
  addNewEvent,
}) {
  if (search || category) {
    return null;
  }
  return (
    <div className="container event-overview mt-5">
      <div>
        <AddButton onClick={addNewEvent} title="Add new event" />
      </div>
      {recommended.length > 0 && (
        <h3 className="text-left mb-4 pb-0">
          {I18n.t("EventsOver recommended events")}
        </h3>
      )}
      {recommended.length > 0 && (
        <div className="row">
          {recommended.map((event, index) => (
            <EventNode event={event} key={index} language={language} />
          ))}
        </div>
      )}
    </div>
  );
}
export default Scrivito.connect(RecommendedEvents);
